import React from 'react';

import styles from './TriangleStepper.module.scss';

const TriangleStepper = ({currentStep, setCurrentStep, isOrder}) => {

    const handleSetLastStep = () => {
        if (isOrder) {
            setCurrentStep('step3');
        }
    }

    return (
        <>
            <div className={styles.triangleStepper}>
                <div
                    onClick={() => setCurrentStep('step1')}
                    className={`${styles.triangleStepper_item} ${currentStep === 'step1' && styles.active}`}
                >
                    Деталі замовлення
                    <div className={`${styles.triangle} ${currentStep === 'step1' && styles.active}`}></div>
                </div>

                <div
                    onClick={() => setCurrentStep('step2')}
                    className={`${styles.triangleStepper_item} ${currentStep === 'step2' && styles.active}`}
                >
                    Пропозиції
                    <div className={`${styles.triangle} ${currentStep === 'step2' && styles.active}`}></div>
                </div>

                <div
                    onClick={handleSetLastStep}
                    className={`${styles.triangleStepper_item} ${currentStep === 'step3' && styles.active} ${!isOrder ? styles.disabled : ''}`}
                >
                    Виконання замовлення
                    <div className={`${styles.triangle} ${currentStep === 'step3' && styles.active}`}></div>
                </div>
            </div>

            <ul className={styles.triangleStepper_mobile}>
                <li
                    className={currentStep === 'step1' ? styles.active : ''}
                    onClick={() => setCurrentStep('step1')}
                >Деталі</li>
                <li
                    className={currentStep === 'step2' ? styles.active : ''}
                    onClick={() => setCurrentStep('step2')}
                >Пропозиції</li>
                <li
                    className={`${currentStep === 'step3' ? styles.active : ''} ${!isOrder ? styles.disabled : ''}`}
                    onClick={() => handleSetLastStep('step3')}
                >Виконання</li>
            </ul>
        </>
    );
};

export default TriangleStepper;
